/* eslint-disable security/detect-object-injection */
import personalizationError from './personalization-error-list';

const validatePersonalization = (personalizationText: string, maxLength: number) => {
  const withEmojis = /\p{Extended_Pictographic}/u;
  if (personalizationText === '') {
    return personalizationError.type.noError;
  }
  if (withEmojis.test(personalizationText)) {
    return personalizationError.type.emoji;
  }
  if (!personalizationText.match('^[\\w ,.?!:;&*=()\'"@#\\[\\]£$€–-]+$')) {
    return personalizationError.type.symbol;
  }
  if (personalizationText.length > maxLength) {
    return personalizationError.type.length;
  }

  return personalizationError.type.noError;
};

const getPersonalizationErrorMessage = (type: keyof typeof personalizationError.list): string =>
  personalizationError.list[type];

export { validatePersonalization, getPersonalizationErrorMessage, personalizationError };
